import { SkapaColors } from '@inter-ikea-guida/skapa';
export const defaultFrameworkTheme = {
    framework: {
        slideshow: {
            headlineColor: SkapaColors.colourStaticBlack
        }
    }
};
//# sourceMappingURL=defaultFrameworkTheme.js.map